<template>
  <div v-if="isVisible" class="back-to-top-container" :class="theme">
    <!-- Icônes à côté -->
    <div class="floating-icons">
      <a href="https://www.instagram.com/novo_julian/" target="_blank" title="Instagram">
        <i class="fa-brands fa-instagram"></i>
      </a>

      <a href="mailto:contact@novostudio.fr" title="Email">
        <i class="bi bi-envelope-at"></i>
      </a>

      <button @click="toggleTheme" class="theme-toggle" title="Changer de thème">
        <i :class="theme === 'light' ? 'bi bi-brightness-high' : 'bi bi-brightness-alt-high'"></i>
      </button>
    </div>

    <!-- Flèche -->
    <div class="back-to-top arrow" @click="scrollToTop">
      &#8593;
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from "vue";

export default {
  props: {
    theme: {
      type: String,
      default: "light",
    },
  },
  emits: ["update-theme"],
  setup(props, { emit }) {
    const isVisible = ref(false);
    const theme = ref(props.theme);

    const handleScroll = () => {
      isVisible.value = window.scrollY > 200;
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const toggleTheme = () => {
      theme.value = theme.value === "light" ? "dark" : "light";
      localStorage.setItem("theme", theme.value);
      document.body.className = theme.value;
      emit("update-theme", theme.value);
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
      theme.value = localStorage.getItem("theme") || props.theme;
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    watch(
      () => props.theme,
      (newTheme) => (theme.value = newTheme)
    );

    return { isVisible, scrollToTop, theme, toggleTheme };
  },
};
</script>

<style scoped>
.back-to-top-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 5000;
  transition: opacity 0.3s ease;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.8);
  opacity: 0.3;
}

.back-to-top-container:hover {
  opacity: 1;
}

.floating-icons {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.floating-icons i {
  opacity: 0.7;
}

.floating-icons i:hover {
  opacity: 1;
  color: rgb(255, 234, 0);

}

.bi-envelope-at {
  padding-top: 5px;
}

.floating-icons a,
.floating-icons button {
  border: none;
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;
  text-decoration: none;
}



.back-to-top {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.arrow:hover {
  color: rgb(255, 234, 0) !important;
  opacity: 1;
  font-size: 50px;
  overflow: hidden;
}

/* Thème clair */
.light .floating-icons a,
.light .floating-icons button,
.light .back-to-top {
  color: #fff;
}



/* Thème sombre */
.dark .floating-icons a,
.dark .floating-icons button,
.dark .back-to-top {
  color: #fff;
}

/* Responsive */
@media (max-width: 768px) {
  .back-to-top-container {
    bottom: 3px;
    right: 0px;
    padding-right: 10px;
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 10px 0 0 10px;
  }
  
  .floating-icons i {
    opacity: 0.8;
    font-size: 25px;
  }
  .floating-icons i:hover{
    color: #fff;
    opacity: 0.8;
  }

  .arrow:hover {
    color: #fff !important;
    opacity: O.7;
    font-size: 24px;
  }

}
</style>
